import React, { useState } from 'react';
import { ACCOUNTS } from '../../data/mockData';
import { Search, Filter, Download } from 'lucide-react';
export function Accounts() {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredAccounts = ACCOUNTS.filter(acc => acc.name.toLowerCase().includes(searchTerm.toLowerCase()) || acc.msisdn.includes(searchTerm) || acc.ref.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="max-w-6xl mx-auto space-y-6" data-id="element-628">
      <div className="flex items-center justify-between" data-id="element-629">
        <h1 className="text-2xl font-semibold text-bone" data-id="element-630">Accounts</h1>
        <div className="flex items-center gap-3" data-id="element-631">
          <button className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-ink-3 border border-white/10 text-sm font-medium text-bone hover:bg-ink-4 transition-colors" data-id="element-632">
            <Filter className="w-4 h-4" data-id="element-633" />
            Filter
          </button>
          <button className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-ink-3 border border-white/10 text-sm font-medium text-bone hover:bg-ink-4 transition-colors" data-id="element-634">
            <Download className="w-4 h-4" data-id="element-635" />
            Export
          </button>
        </div>
      </div>

      <div className="bg-ink-2 border border-white/5 rounded-2xl overflow-hidden" data-id="element-636">
        <div className="p-4 border-b border-white/5 flex items-center gap-4" data-id="element-637">
          <div className="relative flex-1 max-w-md" data-id="element-638">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted" data-id="element-639" />
            <input type="text" placeholder="Search by name, MSISDN, or reference..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-ink border border-white/5 rounded-lg text-sm text-bone placeholder-muted focus:outline-none focus:border-mint focus:ring-1 focus:ring-mint transition-all" data-id="element-640" />
            
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-641">
          <table className="w-full text-left text-sm" data-id="element-642">
            <thead className="bg-ink text-muted uppercase tracking-wider text-xs" data-id="element-643">
              <tr data-id="element-644">
                <th className="px-6 py-4 font-medium" data-id="element-645">Customer</th>
                <th className="px-6 py-4 font-medium" data-id="element-646">Reference</th>
                <th className="px-6 py-4 font-medium" data-id="element-647">Balance</th>
                <th className="px-6 py-4 font-medium" data-id="element-648">Status</th>
                <th className="px-6 py-4 font-medium" data-id="element-649">Last Contact</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5" data-id="element-650">
              {filteredAccounts.map(acc => <tr key={acc.id} className="hover:bg-ink-3/50 transition-colors" data-id="element-651">
                
                  <td className="px-6 py-4" data-id="element-652">
                    <div className="font-medium text-bone" data-id="element-653">{acc.name}</div>
                    <div className="text-muted mono text-xs mt-0.5" data-id="element-654">
                      {acc.msisdn}
                    </div>
                  </td>
                  <td className="px-6 py-4 mono text-bone-dim" data-id="element-655">{acc.ref}</td>
                  <td className="px-6 py-4 font-medium text-bone" data-id="element-656">
                    R {acc.balance.toFixed(2)}
                  </td>
                  <td className="px-6 py-4" data-id="element-657">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${acc.status === 'active' ? 'bg-mint/10 text-mint' : acc.status === 'arrears' ? 'bg-red-500/10 text-red-400' : 'bg-ink-4 text-bone-dim'}`} data-id="element-658">
                    
                      {acc.status.charAt(0).toUpperCase() + acc.status.slice(1)}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-muted" data-id="element-659">
                    {new Date(acc.lastContact).toLocaleDateString()}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {filteredAccounts.length === 0 && <div className="p-8 text-center text-muted" data-id="element-660">
            No accounts found matching "{searchTerm}"
          </div>}
      </div>
    </div>;
}